import { LoaderBindingOptions } from '#/CoreFrameInterfaces';
import Loader from '@/Utility/Loader';
import { ICustomBinding } from "#/DefaultViewExtensionInterfaces";

const loaderBindingInitKey = 'loaderBindingInit';

export default class LoaderBinding implements ICustomBinding {

    public initBinding() {
        ko.bindingHandlers.loader = {
            init: (node: HTMLElement, valueAccessor: () => LoaderBindingOptions, bindings, view, bindingContext) => {
                this.setInitState($(node));
            },
            update: (node: HTMLElement, valueAccessor: () => LoaderBindingOptions, bindings, view, bindingContext) => {
                const $element = $(node);
                const isInit = this.popInitState($element);

                const options = ko.unwrap(valueAccessor());
                const value = typeof options === 'boolean' ? options : options.value;
                if (value) {
                    Loader.getInstance().show($element);
                    return;
                }

                if (isInit) {
                    // Wenn das Binding gerade initialisiert wird und kein Loader angezeigt werden soll,
                    // kann auch kein bestehender Loader vorhanden sein. Somit muss auch kein Loader versteckt werden.
                    return;
                }

                const delay = typeof options === 'boolean' ? 50 : options.hideDelay;
                Loader.getInstance().hide($element, delay);
            }
        };
    }

    private setInitState($element: JQuery) {
        $element.data(loaderBindingInitKey, true);
    }

    private popInitState($element: JQuery): boolean {
        const isInit = $element.data(loaderBindingInitKey) === true;
        if (isInit) {
            $element.removeData(loaderBindingInitKey);
        }
        return isInit;
    }
}